import { render } from "./ResetOptions.vue?vue&type=template&id=ad9cfb56&scoped=true"
import script from "./ResetOptions.vue?vue&type=script&lang=js"
export * from "./ResetOptions.vue?vue&type=script&lang=js"

import "./ResetOptions.vue?vue&type=style&index=0&id=ad9cfb56&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9cfb56"]])

export default __exports__